<div class="oa-sheet client-contact-sheet">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>{{ contact?.id ? 'Editar contato' : 'Novo contato' }}</h2>
        <button type="button" class="oa-icon-btn" (click)="requestClose()" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <form class="oa-sheet__body" id="client-contact-form" [formGroup]="form" (ngSubmit)="save()">
        <p class="required-hint">
            (<span class="mat-placeholder-required">*</span>) Campos obrigatórios
        </p>

        <mat-form-field appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="name" placeholder="Nome do contato" autocomplete="off" required>
            <mat-error *ngIf="form.get('name')?.hasError('required')">Informe o nome</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>E-mail</mat-label>
            <input matInput type="email" inputmode="email" autocapitalize="off" autocomplete="off"
                formControlName="email" placeholder="E-mail do contato" required>
            <mat-error *ngIf="form.get('email')?.hasError('required')">Informe o e-mail</mat-error>
            <mat-error *ngIf="form.get('email')?.hasError('email')">E-mail inválido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Telefone</mat-label>
            <input matInput type="tel" formControlName="phone" placeholder="(00) 00000-0000" autocomplete="off"
                mask="(00) 00009-0000">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Cargo</mat-label>
            <input matInput formControlName="role" placeholder="Ex.: Compras, Financeiro" autocomplete="off">
        </mat-form-field>
    </form>

    <footer class="oa-sheet__footer">
        <button type="button" class="oa-btn oa-btn--ghost" (click)="requestClose()">Cancelar</button>
        <button type="submit" form="client-contact-form" class="oa-btn oa-btn--primary"
            [disabled]="form.invalid || loading">
            Salvar
        </button>
    </footer>
</div>
